var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconEvolveWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;stroke-miterlimit:10;stroke-width:2.01px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 17.15,
    cy: 19.17,
    rx: 17.75,
    ry: 5.7,
    transform: "translate(-7.15 10.72) rotate(-29)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 17.15,
    cy: 18.75,
    rx: 5.7,
    ry: 17.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 17.15,
    cy: 19.17,
    rx: 5.7,
    ry: 17.75,
    transform: "translate(-7.6 26.19) rotate(-64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconEvolveWhite);
export default __webpack_public_path__ + "static/media/streamline-icon-evolve-white.8ba3f6ed.svg";
export { ForwardRef as ReactComponent };